<aside class="agentic-explanation-panel">
  <div class="explanation-icon">
    <mat-icon>warning_amber</mat-icon>
  </div>
  <div class="explanation-copy">
    <h2>Why this matters</h2>
    <p>
      More and more shoppers let AI assistants like ChatGPT or Perplexity search
      and compare products for them. These agents read your page as plain HTML
      text &mdash; they <strong>do not run JavaScript</strong>. If your products
      are only injected after load via JavaScript, your store appears
      practically empty to the AI. In
      <strong>agentic commerce</strong> that means: your products simply
      don&rsquo;t exist for the shopping assistant.
    </p>
  </div>
</aside>
